import {IEnumListEntry} from "../definitions";
export const RESTRICTION_TYPES = {
    LEVEL_GREATER_THAN_OR_EQUALS:1,
    QUEST_COMPLETE:2,
    BUILDING_LEVEL:3,
    MAGIC_LEVEL_GE_THAN:4,
    QUEST_ACTIVE:5,
    HAS_ITEM:7,
    SECTOR_OPENED:11,
    RESOURCE_GOT:12,
    TUTOR_CPOINT_GE_THAN:13,
    COMING_SOON: 14,
    PAY_AVG_MONETARY:15,
    PAY_MONETARY:16,
    PAY_RECENCY:17,
    PAY_FREQUENCY:18,
    LOT_IN_OFFER_BOUGHT:19,
    AFTER_OFFER_DEACTIVATED:20,
    WAS_OFFLINE_FOR:21,
    LEVEL_LESS_THAN_OR_EQUALS:22,
    LEVEL_EQUALS:23,
    AFTER_LAST_OFFER_DEACTIVATED:24,
    RESOURCE_AMOUNT_LESS_THAN:25,
    BUILDING_LEVEL_PENDING:26,
    LEVEL_EQUALS_ONE_OF:27,
    OFFER_WAS_ACTIVATED:28,
    ONE_OF_OFFER_LOTS_BOUGHT:29,
    EVENT_EQUALS:30,
    BUILDING_EXISTS:31,
    EVENT_COMPLETE:32,
    LIMIT_REACHED:33,
    LAST_PERIODICAL_REWARD_COLLECTED:34,
    inv_QUEST_COMPLETE:-2,
    inv_BUILDING_LEVEL:-3,
    inv_MAGIC_LEVEL_GE_THAN:-4,
    inv_QUEST_ACTIVE:-5,
    inv_HAS_ITEM:-7,
    inv_SECTOR_OPENED:-11,
    inv_RESOURCE_GOT:-12,
    inv_TUTOR_CPOINT_GE_THAN:-13,
    inv_LOT_IN_OFFER_BOUGHT:-19,
    inv_BUILDING_EXISTS:-31,
    inv_EVENT_COMPLETE:-32,
    inv_LIMIT_REACHED:-33
};


export const RESTRICTION_TYPES_LIST:IEnumListEntry[] = [
    { id: RESTRICTION_TYPES.LEVEL_GREATER_THAN_OR_EQUALS, label: "Уровень больше или равен"},
    { id: RESTRICTION_TYPES.LEVEL_LESS_THAN_OR_EQUALS, label: "Уровень меньше или равен"},
    { id: RESTRICTION_TYPES.LEVEL_EQUALS, label: "Уровень равен"},
    { id: RESTRICTION_TYPES.QUEST_COMPLETE, label: "Завершенный квест"},
    { id: RESTRICTION_TYPES.BUILDING_LEVEL, label: "Уровень здания больше или равен"},
    /*{ id: RESTRICTION_TYPES.MAGIC_LEVEL_GE_THAN, label: "Маг.уровень больше или равен"},*/
    { id: RESTRICTION_TYPES.QUEST_ACTIVE, label: "Квест активен"},
    { id: RESTRICTION_TYPES.HAS_ITEM, label: "Предмет в наличии"},
    { id: RESTRICTION_TYPES.SECTOR_OPENED, label: "Сектор открыт"},
    { id: RESTRICTION_TYPES.RESOURCE_GOT, label: "Ресурс получен"},
    { id: RESTRICTION_TYPES.TUTOR_CPOINT_GE_THAN, label: "Туториальный чекпоинт больше или равен"},
    { id: RESTRICTION_TYPES.COMING_SOON, label: "Скоро будет"},
    { id: RESTRICTION_TYPES.PAY_AVG_MONETARY, label: "Средний чек"},
    { id: RESTRICTION_TYPES.PAY_MONETARY, label: "Полный чек"},
    { id: RESTRICTION_TYPES.PAY_RECENCY, label: "Последний платеж"},
    { id: RESTRICTION_TYPES.PAY_FREQUENCY, label: "Частота платежей"},
    { id: RESTRICTION_TYPES.LOT_IN_OFFER_BOUGHT, label: "Лот в оффере куплен"},
    { id: RESTRICTION_TYPES.AFTER_OFFER_DEACTIVATED, label: "После деактивации оффера"},
    { id: RESTRICTION_TYPES.AFTER_LAST_OFFER_DEACTIVATED, label: "После деактивации последнего оффера (НЕ ИСПОЛЬЗОВАТЬ"},
    { id: RESTRICTION_TYPES.WAS_OFFLINE_FOR, label: "Был оффлайн"},
    { id: RESTRICTION_TYPES.RESOURCE_AMOUNT_LESS_THAN, label: "Ресурса меньше чем"},
    { id: RESTRICTION_TYPES.BUILDING_LEVEL_PENDING, label: "Ожидаемый уровень здания больше или равен"},
    { id: RESTRICTION_TYPES.LEVEL_EQUALS_ONE_OF, label: "Уровень равен одному из"},
    { id: RESTRICTION_TYPES.OFFER_WAS_ACTIVATED, label: "Оффер был активирован"},
    { id: RESTRICTION_TYPES.ONE_OF_OFFER_LOTS_BOUGHT, label: "Один из лотов куплен"},
    { id: RESTRICTION_TYPES.EVENT_EQUALS, label: "Игрок в ивенте"},
    { id: RESTRICTION_TYPES.BUILDING_EXISTS, label: "Здание существует" },
    { id: RESTRICTION_TYPES.EVENT_COMPLETE, label: "Пройден ивент"},
    { id: RESTRICTION_TYPES.LIMIT_REACHED, label: "Лимит достигнут"},
    { id: RESTRICTION_TYPES.LAST_PERIODICAL_REWARD_COLLECTED, label: "Собрана последняя периодическая награда"},
    { id: RESTRICTION_TYPES.inv_QUEST_COMPLETE, label: "НЕ Завершенный квест"},
    { id: RESTRICTION_TYPES.inv_BUILDING_LEVEL, label: "Уровень здания меньше"},
    /*{ id: RESTRICTION_TYPES.inv_MAGIC_LEVEL_GE_THAN, label: "НЕ Маг.уровень больше или равен"},*/
    { id: RESTRICTION_TYPES.inv_QUEST_ACTIVE, label: "НЕ Квест активен"},
    /*{ id: RESTRICTION_TYPES.inv_HAS_ITEM, label: "НЕ Предмет в наличии"},*/
    { id: RESTRICTION_TYPES.inv_SECTOR_OPENED, label: "НЕ Сектор открыт"},
    /*{ id: RESTRICTION_TYPES.inv_RESOURCE_GOT, label: "НЕ Ресурс получен"},*/
    { id: RESTRICTION_TYPES.inv_TUTOR_CPOINT_GE_THAN, label: "НЕ Туториальный чекпоинт больше или равен"},
    { id: RESTRICTION_TYPES.inv_LOT_IN_OFFER_BOUGHT, label: "НЕ Лот в оффере куплен"},
    { id: RESTRICTION_TYPES.inv_BUILDING_EXISTS, label: "НЕ Здание существует" },
    { id: RESTRICTION_TYPES.inv_EVENT_COMPLETE, label: "НЕ Пройден ивент"},
    { id: RESTRICTION_TYPES.inv_LIMIT_REACHED, label: "НЕ Лимит достигнут"}
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-restrictions.ts